import { createFileRoute, notFound } from '@tanstack/react-router';
import {
  FEATURE_FLAGS,
  useFeatureFlag,
} from '../../../../../../lib/featureFlags';
import { StudyPreparationChat } from '../../../../../../pages/interpretiveReports/studyPreparation/StudyPreparationChat';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/new'
)({
  staticData: { ddViewName: 'experiments-new-interpretation' },
  component: NewInterpretationRoute,
});

// Opens a study preparation, whether or not the sample set has interpretations
function NewInterpretationRoute() {
  const { sampleSetId } = Route.useParams();
  const studyPreparationChatEnabled = useFeatureFlag(
    FEATURE_FLAGS.studyPreparationChat
  );

  if (!studyPreparationChatEnabled) {
    throw notFound();
  }
  // Keyed by sample set: each set has its own conversation, and another
  // set's route keeps this component mounted.
  return <StudyPreparationChat key={sampleSetId} sampleSetId={sampleSetId} />;
}
